module.exports = __webpack_public_path__ + "site/img/168.fc75b543.jpg";